import React from 'react';
import { func } from 'prop-types';

import Form from '../Form';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';
import ButtonGroup from 'elements/Buttons/ButtonGroup';
import CCDateInput from 'elements/Inputs/CCDateInput';
import CCInput from 'elements/Inputs/CCInput';
import CVVInput from 'elements/Inputs/CVVInput';
import { Row } from 'components/Form/Layout';

import styles from './CreditCardForm.css';

const  CreditCardForm = ({ onSubmit }) => (
  <Form className={styles.creditCardForm} onSubmit={onSubmit}>
    <FormField>
      <InputField label="Name on Card" validations={['required']} />
    </FormField>
    <FormField>
      <CCInput label="Card Number" validations={['required', 'credit-card']} />
    </FormField>
    <Row>
      <FormField>
        <CCDateInput label="Expire Date" />
      </FormField>
      <FormField>
        <CVVInput label="Security Code" validations={['cvv']} />
      </FormField>
    </Row>
    <div className="flex flex-justify-end buttons-wrapper">
      <ButtonGroup
        left={{href: '#', children: 'cancel'}}
        right={{children: 'submit'}}
        small
      />
    </div>
  </Form>
);

CreditCardForm.propTypes = {
  onSubmit: func,
};

CreditCardForm.displayName = 'CreditCardForm';

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/uis/components/Form/CreditCardForm/CreditCardForm.js